export const getLanguageLabel = (languageCode: string, fullLabel = false): string => {
    const languageMap: Record<string, { short: string; full: string }> = {
        nl: { short: 'NL', full: 'Nederlands' },
        en: { short: 'EN', full: 'English' },
    };

    const language = languageMap[languageCode];
    if (!language) {
        return languageCode.toUpperCase();
    }

    return fullLabel ? language.full : language.short;
};
